import React from 'react';

interface Props {
  loading: boolean;
  hasData: boolean;
  hasResults: boolean;
  table: React.ReactNode;
  noResults: React.ReactNode;
  noData: React.ReactNode;
}

const OverviewContent: React.FC<Props> = ({ loading, hasData, hasResults, table, noResults, noData }) => {
  if (!loading && !hasData) return <>{noData}</>;
  if (!loading && hasData && !hasResults) return <>{noResults}</>;
  return <>{table}</>;
};

export default OverviewContent;
